/* CALOO — theme behaviour: accordion, reveal, header, variant pickers, AJAX cart */
(function () {
  'use strict';

  /* --- Accordion (FAQ) --- */
  function initAccordions(root) {
    (root || document).querySelectorAll('[data-accordion]').forEach(function (group) {
      if (group.dataset.accordionReady) return;
      group.dataset.accordionReady = '1';

      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.faq-q');
        if (!btn || !group.contains(btn)) return;

        var item = btn.closest('.faq-item');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        group.querySelectorAll('.faq-item').forEach(function (other) {
          other.classList.remove('is-open');
          var ob = other.querySelector('.faq-q');
          if (ob) ob.setAttribute('aria-expanded', 'false');
          var s = other.querySelector('.faq-q__sign');
          if (s) s.textContent = '+';
        });

        if (!isOpen && item) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          var sign = btn.querySelector('.faq-q__sign');
          if (sign) sign.textContent = '–';
        }
      });
    });
  }

  /* --- Scroll reveal --- */
  function revealHashTarget() {
    if (!window.location.hash) return;
    var target;
    try { target = document.querySelector(window.location.hash); } catch (err) { return; }
    if (!target) return;
    /* reveal the target's own section and every section above it, so an anchor
       jump never lands on a still-hidden block */
    var section = target.closest('[data-fade]') || target;
    document.querySelectorAll('[data-fade]').forEach(function (el) {
      if (el === section || el.contains(section) || el.compareDocumentPosition(section) & Node.DOCUMENT_POSITION_FOLLOWING) {
        el.classList.add('is-visible');
      }
    });
  }

  function initReveal(root) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = (root || document).querySelectorAll('[data-fade]:not(.is-visible)');

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { io.observe(el); });

    revealHashTarget();
  }

  /* --- Product gallery thumbs --- */
  function initProductThumbs(root) {
    (root || document).querySelectorAll('[data-product-gallery]').forEach(function (gal) {
      if (gal.dataset.galleryReady) return;
      gal.dataset.galleryReady = '1';
      var main = gal.querySelector('[data-gallery-main]');
      gal.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-gallery-thumb]');
        if (!thumb || !main) return;
        main.src = thumb.dataset.full || thumb.src;
        main.alt = thumb.alt;
      });
    });
  }

  /* --- Sticky glass header: drawer + scrolled state --- */
  function initHeader(root) {
    var hdr = (root || document).querySelector('[data-header]');
    if (!hdr || hdr.dataset.ready) return;
    hdr.dataset.ready = '1';

    var toggle = hdr.querySelector('[data-menu-toggle]');
    var drawer = hdr.querySelector('[data-menu-drawer]');
    var closeBtn = hdr.querySelector('[data-menu-close]');
    var backdrop = hdr.querySelector('[data-menu-backdrop]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      hdr.classList.add('menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button, input');
      if (first) setTimeout(function () { first.focus(); }, 50);
    }
    function close() {
      hdr.classList.remove('menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        hdr.classList.contains('menu-open') ? close() : open();
      });
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (backdrop) backdrop.addEventListener('click', close);
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('a')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && hdr.classList.contains('menu-open')) close();
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        hdr.classList.toggle('is-scrolled', window.scrollY > 24);
        ticking = false;
      });
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }


  /* --- Variant picker (radio pills or <select>) → hidden id + price --- */
  function initVariantPickers(root) {
    (root || document).querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      if (picker.dataset.ready) return;
      picker.dataset.ready = '1';
      var form = picker.closest('form');
      if (!form) return;
      var hidden = form.querySelector('[data-variant-input]');
      var priceEl = form.querySelector('[data-price-target]');
      var btn = form.querySelector('[data-add-btn]');
      var label = btn && btn.querySelector('[data-add-label]');
      var origLabel = label ? label.textContent : '';

      function apply(el) {
        if (!el) return;
        if (hidden) hidden.value = el.dataset.variantId || el.value;
        if (priceEl && el.dataset.price) priceEl.textContent = el.dataset.price;
        var avail = el.dataset.available !== 'false';
        if (btn) {
          btn.disabled = !avail;
          if (label) label.textContent = avail ? origLabel : 'אזל מהמלאי';
        }
        picker.querySelectorAll('label').forEach(function (l) {
          var inp = l.querySelector('input');
          l.classList.toggle('is-active', !!(inp && inp.checked));
        });
      }
      picker.addEventListener('change', function (e) {
        var t = e.target;
        if (t.tagName === 'SELECT') apply(t.options[t.selectedIndex]);
        else if (t.type === 'radio') apply(t);
      });
    });
  }

  /* --- AJAX add to cart + toast + header count --- */
  var toastTimer = null;
  function showToast(title, count, ok) {
    var toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    var t = toast.querySelector('[data-toast-title]');
    var m = toast.querySelector('[data-toast-msg]');
    if (t) t.textContent = ok ? (toast.dataset.okTitle || 'נוסף לעגלה') : (toast.dataset.errTitle || 'משהו השתבש');
    if (m) m.textContent = ok ? title : (toast.dataset.errMsg || 'נסו שוב.');
    var c = toast.querySelector('[data-toast-count]');
    if (c) c.textContent = ok && count ? count : '';
    toast.classList.toggle('is-error', !ok);
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 4200);
  }
  function updateHeaderCount(n) {
    document.querySelectorAll('.hdr__cart').forEach(function (cartLink) {
      var badge = cartLink.querySelector('.hdr__count');
      if (n > 0) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'hdr__count'; cartLink.appendChild(badge); }
        badge.textContent = n;
        badge.classList.remove('is-bump'); void badge.offsetWidth; badge.classList.add('is-bump');
      } else if (badge) { badge.remove(); }
      cartLink.setAttribute('aria-label', 'עגלה, ' + n + ' פריטים');
    });
  }
  function initAjaxCart(root) {
    (root || document).querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
      if (form.dataset.ajaxReady) return;
      form.dataset.ajaxReady = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return; // fall back to normal submit
        e.preventDefault();
        var btn = form.querySelector('[data-add-btn]') || form.querySelector('[type="submit"]');
        var label = btn && btn.querySelector('[data-add-label]');
        var orig = label ? label.textContent : '';
        if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
        if (label) label.textContent = 'מוסיף…';

        var fd = new FormData(form);
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', body: fd, headers: { 'Accept': 'application/json' }
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && res.j.description || 'error');
          var item = res.j;
          var name = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : '');
          return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            updateHeaderCount(cart.item_count);
            showToast(name, cart.item_count, true);
            if (label) label.textContent = '✓ נוסף';
            if (btn) btn.classList.add('is-added');
            setTimeout(function () {
              if (label) label.textContent = orig;
              if (btn) btn.classList.remove('is-added');
            }, 1800);
          });
        }).catch(function () {
          showToast('', 0, false);
          if (label) label.textContent = orig;
        }).then(function () {
          if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        });
      });
    });
    var toast = document.querySelector('[data-cart-toast]');
    if (toast && !toast.dataset.ready) {
      toast.dataset.ready = '1';
      var x = toast.querySelector('[data-toast-close]');
      if (x) x.addEventListener('click', function () { toast.classList.remove('is-visible'); });
    }
  }


  /* --- Compact order rows: variant pills + qty stepper + live total --- */
  function formatMoney(cents, fmt) {
    var v = (cents || 0) / 100;
    var f = fmt || '₪{{amount}}';
    var s;
    if (f.indexOf('amount_no_decimals') > -1) s = Math.round(v).toString();
    else s = v.toFixed(2).replace(/\.00$/, '');
    if (f.indexOf('amount_with_comma_separator') > -1) s = s.replace('.', ',');
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
  }
  function initOrderForms(root) {
    (root || document).querySelectorAll('form[data-order]').forEach(function (form) {
      if (form.dataset.orderReady) return;
      form.dataset.orderReady = '1';
      var hidden = form.querySelector('[data-variant-input]');
      var qty = form.querySelector('[data-qty]');
      var total = form.querySelector('[data-total]');
      var btn = form.querySelector('[data-add-btn]');
      var fmt = form.dataset.money;

      function current() {
        var r = form.querySelector('input[type="radio"]:checked');
        if (r) return r;
        var sel = form.querySelector('select[data-pick]');
        return sel ? sel.options[sel.selectedIndex] : null;
      }
      function refresh() {
        var r = current();
        if (!r) return;
        if (hidden) hidden.value = r.dataset.variantId || r.value;
        var q = Math.max(1, Math.min(99, parseInt(qty && qty.value, 10) || 1));
        if (qty) qty.value = q;
        if (total) total.textContent = formatMoney(parseInt(r.dataset.priceCents, 10) * q, fmt);
        if (btn) btn.disabled = r.dataset.available === 'false';
        form.querySelectorAll('label').forEach(function (l) {
          var inp = l.querySelector('input[type="radio"]');
          if (inp) l.classList.toggle('is-active', inp.checked);
        });
      }
      form.addEventListener('change', refresh);
      form.addEventListener('input', function (e) { if (e.target === qty) refresh(); });
      form.addEventListener('click', function (e) {
        var b = e.target.closest('[data-qty-step]');
        if (!b || !qty) return;
        qty.value = (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10);
        refresh();
      });
      refresh();
    });
  }

  function init(root) {
    initOrderForms(root);
    initAccordions(root);
    initReveal(root);
    initProductThumbs(root);
    initHeader(root);
    initVariantPickers(root);
    initAjaxCart(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* An in-page anchor click must never land on a section that is still faded out */
  window.addEventListener('hashchange', revealHashTarget);
  window.addEventListener('load', revealHashTarget);

  /* Re-run inside the Shopify theme editor when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
